import {NoteStatus} from './NoteStatus';
import {Message} from './Message';
import {NotePriority} from './NotePriority';

export class Note {
  id: String
  code: String
  topic: String
  agents: String[]
  users: String[]
  priority: NotePriority
  messages: Message[]
  status: NoteStatus
  company: String
  workspace: String

  static fromDto(obj: any): Note {
    const res = new Note();

    res.id = obj.id;
    res.code = obj.code;
    res.topic = obj.topic;
    res.agents = obj.agents;
    res.users = obj.users;
    res.priority = obj.priority;
    res.messages = Message.fromArrayDto(obj.messages);
    res.status = obj.status;
    res.company = obj.company;
    res.workspace = obj.workspace;

    return res;
  }
}

export class LightNote {
  deliveryNumber: String
  subject: String
  link: String
  creationDate: Number

  static fromDto(obj: any): LightNote {
    const res = new LightNote();

    res.deliveryNumber = obj.deliveryNumber;
    res.subject = obj.subject;
    res.link = obj.link;
    res.creationDate = obj.creation_date;

    return res;
  }
}
